export function hideDelete(content,bol_delete,user_status) {
    if (bol_delete?.toString()=="1" || user_status <= 0) {
        return '<div className=" py-2 text-red-300 italic rounded-md">Message Removed</div>';
    } 
    return content;
}